<template>
<b-card header="Shipping" header-bg-variant=primary>
  <b-alert :show=ccIncreased variant=danger class="mb-0 py-0 small">
    You probably shouldn't increase the shipping cost on a CC order!
  </b-alert>
  <b-alert :show=gcChanged variant=warning class="mb-0 py-0 small">
    You cannot change the payment amount on a gift card or store credit order!
  </b-alert>
  <b-form-row class='my-1'>
    <b-col cols=4>
      <b-form-row class='my-1'>
        <b-col cols=2><label>Carrier</label></b-col>
        <b-col>
          <b-form-select required v-model=selectedCarrier :options=carriers :disabled="disabled || !this.carrierDictionary" />
        </b-col>
      </b-form-row>
      <b-form-row class='my-1'>
        <b-col cols=2><label>Service</label></b-col>
        <b-col>
          <input-merger required :dict=order.shippingAddress.shippingPriority select :select-options=services :disabled="disabled || !selectedCarrier" />
        </b-col>
      </b-form-row>
      <b-form-row class='my-1'>
        <b-col cols=2><label>Price</label></b-col>
        <b-col v-if="!!this.order.shippingAddress.shippingPriority">
          <b-alert v-if="!this.order.shippingAddress.shippingPriority.edited" variant=danger show class="mb-0 py-2 small">
            A shipping service has not been selected!
          </b-alert>
          <input-merger v-else :dict=order.shippingTotal type=number :disabled=disabled @input=handlePaste />
        </b-col>
      </b-form-row>
    </b-col>
    <b-col>
      <address-form :address=order.shippingAddress />
    </b-col>
  </b-form-row>
</b-card>
</template>

<script>
import axios from 'axios';
import InputMerger from '../../utility/InputMerger'
import AddressForm from './AddressForm'

const BASE_API = process.env.VUE_API_ROOT;

export default {
  props: {
    order: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    InputMerger,
    AddressForm,
  },
  data() {
    return {
      loaded: false,
      carrierDictionary: [],
      selectedCarrier: undefined,
    };
  },
  computed: {
    carriers() {
      if (!this.carrierDictionary) return []
      return Object.keys(this.carrierDictionary)
    },
    services() {
      if (!this.carrierDictionary || !this.selectedCarrier) return []
      return this.carrierDictionary[this.selectedCarrier].map(x => x.name)
    }
  },
  methods: {
    handlePaste(e) {
      this.order.shippingTotal.edited = Number(e.replace(/ /g, "").replace(/\,/g, "").replace(/\$/g, "").replace(/\.*$/, ""))
    }
  },
  mounted() {
    switch (this.order.websiteName) {
      case 'vtex':
        axios.get(`${BASE_API}/vtex/shipping/services`).then(r => {
          this.carrierDictionary = { 'VTEX': r.data.filter(x => x.isActive) }
          this.selectedCarrier = 'VTEX'
        })
        break;
      case 'workarea':
        axios.get(`${BASE_API}/workarea/shipping_services`).then(r => {
          this.carrierDictionary = r.data.filter(x => x.active).reduce((m, i) => {
            (m[i['carrier']] = m[i['carrier']] || []).push(i)
            return m
          }, {})
          this.selectedCarrier = r.data.filter(x => x.name == this.order.shippingAddress.shippingPriority.edited)[0].carrier
        })
        break;
      default:
        console.error("Editing is not supported for this order!!")
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/sales-order/edit-order-2/ShippingEditor.vue